export const setting = {
  apiHost: process.env.VUE_APP_API_HOST,
  siteHost: process.env.VUE_APP_SITE_HOST,
  socketHost: process.env.VUE_APP_SOCKET_HOST,
  authHost: process.env.VUE_APP_AUTH_HOST,
  widgetHost: process.env.VUE_APP_WIDGET_HOST,
  gqlApiHost: process.env.VUE_APP_GQL_API_HOST
};
